module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }